export default {
  openDrawer: state => state.openDrawer,
  topBanner: state => state.topBanner,
  loadingScreen: state => state.loadingScreen,
  announcement: state => state.announcement,
  showNavbar: state => state.showNavbar
}
